// utils/leuUtils.js
// Shared LEU display utilities for the driver product surface.
// Original IP — LoadDash Services LLC

// Display-only fallback LEU mapping. Used only when predicted_leu,
// confirmed_leu, and estimated_leu are all absent from the job row.
// Canonical LEU values: Small=1, Half=2, ThreeQ=3, Full=6
export const DISPLAY_TIER_LEU_MAP = { Small: 1, Half: 2, ThreeQ: 3, Full: 6 };

export function jobLEU(job) {
  const valid = (v) => v != null && v <= 6;
  if (valid(job.confirmed_leu)) return job.confirmed_leu;
  if (valid(job.predicted_leu)) return job.predicted_leu;
  return job.estimated_leu
    ?? DISPLAY_TIER_LEU_MAP[job.size]
    ?? null;
}

export function fmtLEU(v) { return v != null ? v.toFixed(1) : "—"; }

/**
 * LEU intelligence: compare system-assigned vs provider-verified LEU.
 * Returns structured insight for analytics and UI exposure.
 */
export function getLEUInsight(request) {
  const systemLeu = request.confirmed_leu ?? request.predicted_leu ?? request.estimated_leu ?? null;
  const verifiedLeu = request.provider_verified_leu ?? null;
  if (systemLeu == null || verifiedLeu == null) {
    return { systemLeu, verifiedLeu, delta: null, percentDiff: null, pricingImpact: null, classificationAccuracy: null };
  }
  const delta = verifiedLeu - systemLeu;
  const percentDiff = systemLeu > 0 ? Math.round((delta / systemLeu) * 100) : null;
  const accuracy = Math.abs(delta) <= 1 ? "accurate" : delta > 0 ? "underestimated" : "overestimated";
  // Pricing impact: difference in tier price between verified and system LEU
  const tierPrice = (leu) => {
    const sorted = [{ fill: 6, price: 295 }, { fill: 3, price: 175 }, { fill: 2, price: 120 }, { fill: 1, price: 75 }];
    return (sorted.find(t => leu >= t.fill) || sorted[sorted.length - 1]).price;
  };
  const pricingImpact = tierPrice(verifiedLeu) - tierPrice(systemLeu);
  return { systemLeu, verifiedLeu, delta, percentDiff, pricingImpact, classificationAccuracy: accuracy };
}
